import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { inject } from '@angular/core';

export const freelanceGuard: CanActivateFn = (route, state) => {
  const userSvc = inject(UserService);

  if (userSvc.userConnected.UserFreelance) {
    return false;
  }

  return true;
};
